import { EventSubscriberRepository } from '@amityco/js-sdk';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { logUI, logAndylitics } from "../../api/andyliticsApi";
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import * as msgs from "../../constants/textConstants";
import * as tools from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import NotAuthorized from '../common/NotAuthorized';
import Spinner from '../common/spinner';
import StatusBanner from '../common/StatusBanner';
import { Button, ContentSwitcher, Typography, Table, LinkText, Modal, Toast } from "../ecosystem";
import InputForm from './InputForm';
import PrayerCard from './PrayerCard';
import { PageHeading } from '../ecosystem/mybswh';

let _activeTab = '1';
let _sessionStartTime = null;
let _sendSessionStartTime = true;
let _livePrayers = null;
let _liveMyPrayers = null
let _communityTopic = null;
let _userName = '';
let _prayersCount = 0;

function PrayerWall({
    isPrayerWallAdmin, token, memberId, userName, lanId, connectionState, activeTab, _prayerOfTheWeek, allPrayers, myPrayers, hasError, myRecentPrayerPostId, loadingMore,
    onEnteringPrayerWall, onLeavingPrayerWall, setupSession, subscribeToCommunity, updateUserRole, setConnectionState, setActiveTab,
    getPrayerOfTheWeek, getAllPrayers, getMyPrayers, getNextPrayers, updatePrayerOfTheWeek, updateAllPrayers, updateMyPrayers, refreshAllPrayers, refreshMyPrayers, screenBreakPoint,
    getUsersDeletedPosts, usersDeletedPosts, updateUsersDeletedPosts, banUser
}) {
    const [activeTabBeforeRequest, setActiveTabBeforeRequest] = useState('1');
    const [editingPrayer, setEditingPrayer] = useState(null);
    const [toastMessage, setToastMessage] = useState(null);
    const [showMiniSpinner, setShowMiniSpinner] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [showNewPost, setShowNewPost] = useState(false);
    const [scrollY, setScrollY] = useState({ '1': 0, '2': 0, '3': 0, '4': 0 });
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    let timerHandle = null;
    const options = ["All Posts", "My Posts", "Moderating"]
    const defaultIndex = activeTab - 1;
    let disablePrayerOfTheWeek = true;
    const enablePrayerOfTheWeek = window && window.serverData && window.serverData.data ? window.serverData.data.enablePrayerOfTheWeek : false;
    let isSuperAdmin = false;
    if (lanId) {
        const superAdmins = window.serverData.data.superAdmins;
        isSuperAdmin = superAdmins && superAdmins.toLowerCase().indexOf(lanId.toLowerCase()) !== -1;
    }
    const tableHeader = ["User ID", "Reported", "Deleted Post", "Status"];
    const bannedTableHeader = ["Banned users", "", "", ""];
    const activeUsers = [];
    const activeUsersList = usersDeletedPosts && usersDeletedPosts.length > 0 && usersDeletedPosts.filter(post => post.status == "Active");
    const lastRow = { id: "lastRow", items: ["", "", "", ""] };
    if (isSuperAdmin) {
        tableHeader.push("Action");
        bannedTableHeader.push("");
        lastRow.items.push("");
    }

    activeUsersList && activeUsersList.sort((a, b) => b.reported - a.reported).map((post) => {
        //const user = Object.values(post)
        const user = [
            <Typography type="meta-02">{post.userId}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.reported}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.deleted}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.status}</Typography>
        ];
        if (isSuperAdmin) {
            user.push(<LinkText as="button" type="button" onClick={() => { setIsOpen(true); setSelectedUser(post) }}>Ban user</LinkText>);
        }
        activeUsers.push({ id: post.userId, items: user })
        activeUsersList.length == activeUsers.length && activeUsers.push(lastRow);
    })

    const bannedUsers = [];
    const bannedUsersList = usersDeletedPosts && usersDeletedPosts.length > 0 && usersDeletedPosts.filter(post => post.status == "Banned")
    bannedUsersList && bannedUsersList.sort((a, b) => b.reported - a.reported).map((post) => {
        //const user = Object.values(post);
        const user = [
            <Typography type="meta-02">{post.userId}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.reported}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.deleted}</Typography>,
            <Typography type="body-02" color="$color-primary-a2">{post.status}</Typography>,
        ];
        if (isSuperAdmin) {
            user.push("")
        }
        bannedUsers.push({ id: post.userId, items: user })
    })

    const hideMiniSpinner = () => {
        if (showMiniSpinner) {
            setShowMiniSpinner(false);
        }
    }

    const handleScroll = (e) => {
        const livePrayers = _activeTab === '1' ? _livePrayers : _activeTab === '2' ? _liveMyPrayers : null;
        if (livePrayers && livePrayers.hasMore) {
            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop -
                20 <=
                e.target.scrollingElement.clientHeight;
            if (bottom) {
                setShowMiniSpinner(true);
                getNextPrayers((gotMore, error) => {
                    if (error) {
                        onActionComplete({ confirmationMessage: "Oh no! We are having issues loading more prayers. Please try again later." }, error !== null)
                    } else if (gotMore) {
                        scrollDown();
                    } else {
                        //window.scrollBy(0, -20);
                    }
                });
            }
        }
        else {
            setShowMiniSpinner(false);
        }
        if (_activeTab === '1' && window.scrollY <= 200) {
            setShowNewPost(false);
        }
    };

    const scrollDown = () => {
        if (typeof window !== 'undefined') {
            let count = 0;
            var timerHandle = setInterval(() => {
                if (count++ < 20 && window.scrollY < document.body.clientHeight - 1400) {
                    window.scrollBy(0, 10);
                }
                else {
                    clearInterval(timerHandle);
                }
            }, 22);
        }
    };

    const loadPosts = () => {
        getPrayerOfTheWeek(livePrayers => {
            if (livePrayers) {
                livePrayers.on('dataUpdated', prayers => {
                    updatePrayerOfTheWeek(prayers, livePrayers);
                    logUI(types.GET_PRAYER_OF_THE_WEEK_SUCCESS, new Date(), tools.getURLPath(), { count: prayers ? prayers.length : 0 }, memberId);
                    hideMiniSpinner();
                });
                livePrayers.on('dataError', error => {
                    console.log('getPrayerOfTheWeek', error);
                    hideMiniSpinner();
                });
            }
        });
        getAllPrayers(livePrayers => {
            if (livePrayers) {
                livePrayers.on('dataUpdated', prayers => {
                    _livePrayers = livePrayers;
                    if (_prayersCount > prayers.length) {
                        setTimeout(() => _getUsersDeletedPosts(), 1000);
                    }
                    _prayersCount = prayers.length;

                    updateAllPrayers(prayers, livePrayers, _sendSessionStartTime ? _sessionStartTime : null, gotNewPost => {
                        logUI(types.GET_ALL_PRAYERS_SUCCESS, _sendSessionStartTime ? _sessionStartTime : new Date(), tools.getURLPath(), { count: prayers ? prayers.length : 0 }, memberId);
                        if (gotNewPost && window.scrollY > 200) {
                            setShowNewPost(true);
                        }
                        hideMiniSpinner();
                    });
                    _sendSessionStartTime = false;
                });
                livePrayers.on('dataError', error => {
                    console.log('getAllPrayers', error);
                    hideMiniSpinner();
                });
            }
        });
        getMyPrayers(memberId, livePrayers => {
            if (livePrayers) {
                livePrayers.on('dataUpdated', prayers => {
                    if (prayers && prayers.length && prayers[0].postedUserId !== memberId)
                        return;
                    _liveMyPrayers = livePrayers;
                    updateMyPrayers(prayers, livePrayers);
                    logUI(types.GET_MY_PRAYERS_SUCCESS, new Date(), tools.getURLPath(), { count: prayers ? prayers.length : 0 }, memberId);
                    hideMiniSpinner();
                });
                livePrayers.on('dataError', error => {
                    console.log('getMyPrayers', error);
                    hideMiniSpinner();
                });
            }
        });
        _getUsersDeletedPosts();
    }

    useEffect(() => {
        if (loadingMore !== undefined && !loadingMore) {
            setShowMiniSpinner(loadingMore);
        }
    }, [loadingMore]);

    useEffect(() => {
        if (userName) {
            _userName = userName;
        }
    }, [userName]);

    useEffect(() => {
        _getUsersDeletedPosts();
        window.addEventListener('scroll', handleScroll);
        if (_sessionStartTime === null) {
            _sessionStartTime = moment();
            onEnteringPrayerWall(_sessionStartTime);
            logUI(types.PRAYER_WALL_ENTERED, new Date(), tools.getURLPath(), null, memberId, _sessionStartTime);
        }
        if (memberId && !hasError) {
            setupSession(memberId, token, (response, error) => {
                setTimeout(() => loadPosts(), 3000);
                //loadPosts();
                //setTimeout(() => {
                /*subscribeToCommunity(communityTopic => {
                    _communityTopic = communityTopic;
                    console.log('subscribing with community topic', communityTopic);
                    loadPosts();
                });*/
                if (response && response.currentUser) {
                    response.currentUser.on('dataUpdated', user => {
                        const userRole = user.roles.length !== 0 ? user.roles[0] : 'user';
                        updateUserRole(userRole);
                        logUI(types.UPDATE_AMITY_USER_ROLE, new Date(), tools.getURLPath(), { userRole }, memberId);
                    });
                }
                //}, 5000);
                if (!timerHandle) {
                    timerHandle = window.setInterval(refresh, 1000 * window.serverData.data.prayersRefreshIntervalInSeconds);
                }
            });
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cleanup();
            let sessionDurationInMinutes = null;
            if (_sessionStartTime) {
                sessionDurationInMinutes = moment.duration(moment().diff(_sessionStartTime)).asMinutes().toFixed(2);
            }
            onLeavingPrayerWall(sessionDurationInMinutes);
            logAndylitics('"WEB_UI', types.PRAYER_WALL_LEFT, new Date(), new Date(), null, memberId, sessionDurationInMinutes, tools.getURLPath(), _userName);
            //logUI(types.PRAYER_WALL_LEFT, new Date(), tools.getURLPath(), { userName: _userName }, memberId, sessionDurationInMinutes);
            if (_communityTopic) {
                EventSubscriberRepository.unsubscribe(_communityTopic);
            }
        };
    }, [memberId]);

    useEffect(() => {
        scrollToLatest();
    }, [myRecentPrayerPostId]);

    useEffect(() => {
        window.scrollTo(0, scrollY[activeTab]);
        _activeTab = activeTab;
    }, [activeTab]);

    const cleanup = () => {
        if (timerHandle) {
            window.clearInterval(timerHandle);
            timerHandle = null;
        }
    };

    const saveScrollY = () => {
        scrollY[activeTab] = window.scrollY;
        setScrollY(scrollY);
    };

    const refresh = (tab) => {
        if (tab === '1') {
            refreshAllPrayers();
        }
        else if (tab === '2') {
            refreshMyPrayers(memberId);
        }
        else {
            refreshAllPrayers();
            refreshMyPrayers(memberId);
        }
    };

    const switchPrayers = tab => {
        saveScrollY();
        setActiveTab(tab, memberId);
        refresh(tab);
        if (tab === activeTab) {
            scrollToTop();
        }
    };

    const renderRequestButton = (position, text, onClick) => {
        return (enablePrayerOfTheWeek ?
            <div className={`prayer-request-button ${position} ml-auto mr-auto`}>
                <Button size="sm" onClick={onClick} disabled={disablePrayerOfTheWeek}>{text}</Button>
            </div> : null
        );
    };

    const scrollToTop = () => {
        if (typeof window !== 'undefined') {
            const timerHandle = setInterval(() => {
                if (document.body.scrollTop != 0 || document.documentElement.scrollTop != 0)
                    window.scrollBy(0, -50); else clearInterval(timerHandle);
            }, 10);
        }
    };

    const scrollToLatest = () => {
        let recentPrayer = document.getElementById(myRecentPrayerPostId);
        if (recentPrayer) {
            setTimeout(() => {
                recentPrayer.scrollIntoView({
                    block: 'center',
                    behaviour: 'smooth',
                    inline: 'center',
                }),
                    3000;
            });
        }
    };

    const switchToForm = data => {
        saveScrollY();
        if (activeTab !== '4') {
            setActiveTabBeforeRequest(activeTab);
        }
        setToastMessage('');
        setEditingPrayer(data);
        setActiveTab('4', memberId);
    };

    const onActionComplete = (data, isFailed) => {
        if (activeTab === '4') {
            setActiveTab(activeTabBeforeRequest, memberId);
        }
        if (data) {
            setIsFailed(isFailed);
            setToastMessage(data.confirmationMessage);
        }
    };

    const switchTab = (value) => {
        if (value === 'All Posts') {
            switchPrayers('1')
        } else if (value === 'My Posts') {
            switchPrayers('2')
        }
        else if (value === 'Moderating') {
            switchPrayers('3')
        }
    }

    const _getUsersDeletedPosts = () => {
        getUsersDeletedPosts(response => {
            if (response) {
                updateUsersDeletedPosts(response);
            }
        });
    };

    const onBanUser = (value) => {
        banUser(value.userId, (response, error) => {
            setIsOpen(false);
            _getUsersDeletedPosts();
            onActionComplete(error ?
                { success: !error, confirmationMessage: consts.BAN_USER_ERROR } :
                { success: !error, confirmationMessage: consts.BAN_USER_SUCCESS },
                error
            );
        });
    }

    //const lastPrayerDate = allPrayers && allPrayers.length ? new Date(allPrayers[allPrayers.length - 1].createdAt) : null;
    //const myPrayersFiltered = lastPrayerDate && myPrayers && myPrayers.length ? myPrayers.filter(p => p.createdAt >= new Date(lastPrayerDate)) : [];
    disablePrayerOfTheWeek = true;
    if (allPrayers) {
        const index = allPrayers.findIndex(p => p.tags && p.tags.indexOf('prayerOfTheWeek') > -1 && tools.calculateDateInDays(new Date(), new Date(p.createdAt)) <= 7);
        if (index === 0) {
            // do nothing; the prayer of the week is already at the top
        }
        else if (index > 0) {
            const prayerOfTheWeek = allPrayers.splice(index, 1);
            allPrayers.unshift(prayerOfTheWeek[0]);
        }
        else if (_prayerOfTheWeek && tools.calculateDateInDays(new Date(), new Date(_prayerOfTheWeek.createdAt)) <= 7) {
            allPrayers.unshift(_prayerOfTheWeek);
        }
        else {
            disablePrayerOfTheWeek = false;
        }
    }

    return (isPrayerWallAdmin === undefined
        ? <Spinner />
        : isPrayerWallAdmin
            ? <>
                <div className={"container-fluid body-content prayerfeature-container " + (activeTab === '4' ? "prayer-request-form" : "sticky-prayer-footer")} >
                    {!hasError || (allPrayers && allPrayers.length > 0)
                        ? <>
                            {activeTab !== '4' &&
                                <>
                                    <div className="row prayer-header">
                                        <div className="col-12 prayer-header__content maxWidth-content">
                                            <PageHeading heading="Community Support" />
                                        </div>
                                    </div>
                                    <div className="row prayers-nav">
                                        <div className="col-12 prayers-nav__tabs maxWidth-content">
                                            <div className='prayers-nav__switcher'>
                                                <ContentSwitcher options={options} onChange={switchTab} size={"lg"} defaultIndex={defaultIndex} />
                                            </div>
                                            <div className="ml-auto">
                                                {renderRequestButton('header-button', "Add weekly update", () => switchToForm(null))}
                                            </div>
                                        </div>
                                        <div className="prayerpost__toast-container">
                                            <div className="prayerpost__toast">
                                                <Toast
                                                    open={toastMessage ? true : false}
                                                    toggle={() => setToastMessage('')}
                                                    onCloseClick={isFailed ? () => setToastMessage('') : undefined}
                                                    colorStyle={isFailed ? "error" : "default"}
                                                    icon={isFailed ? "exclamation" : undefined}
                                                    autoClose
                                                >{toastMessage}
                                                </Toast>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {showNewPost && activeTab === '1' && window.scrollY > 200 &&
                                <div className="new-post-btn">
                                    {renderRequestButton('', "new post", () => { scrollToTop(); setShowNewPost(false); })}
                                </div>
                            }

                            <div className="row prayers-container">
                                <div className="col-12 maxWidth-content prayers-container__content">
                                    {activeTab === '1' &&
                                        <>
                                            {allPrayers && allPrayers.length > 0 &&
                                                allPrayers.map(prayer => (
                                                    <PrayerCard
                                                        key={prayer.postId}
                                                        prayer={prayer}
                                                        memberId={memberId}
                                                        isSuperAdmin={isSuperAdmin}
                                                        onEdit={switchToForm}
                                                        onActionComplete={onActionComplete}
                                                    />
                                                ))
                                            }
                                        </>
                                    }
                                    {activeTab === '2' &&
                                        <>
                                            {myPrayers && myPrayers.length > 0
                                                ? myPrayers.map(prayer => (
                                                    <PrayerCard
                                                        key={prayer.postId}
                                                        prayer={prayer}
                                                        memberId={memberId}
                                                        isSuperAdmin={isSuperAdmin}
                                                        onEdit={switchToForm}
                                                        onActionComplete={onActionComplete}
                                                    />
                                                ))
                                                : <div className="row prayers-heading">
                                                    <div className="col-12">
                                                        <div className="row page-title">
                                                            <div className="col-12 prayers-heading-no-prayers">
                                                                <div className="svg-prayer-hands" />
                                                                <div>{consts.NO_POST_MESSAGE}</div>
                                                                <div>{consts.NO_POST_SECOND_MESSAGE}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                    {activeTab === '4' &&
                                        <>
                                            <div className="row prayers-heading ">
                                                <div className="col-12">
                                                    <div className="row page-title">
                                                        <div className="prayers-heading-message">
                                                            <Typography type="heading-03" >{editingPrayer ? 'Edit post' : 'Add weekly update'}</Typography>
                                                            {/*<div>{consts.POST_DISCLAIMER}</div>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <InputForm memberId={memberId} connectionState={connectionState} data={editingPrayer} onActionComplete={onActionComplete} />
                                        </>
                                    }
                                    {activeTab === '3' &&
                                        <>
                                            <div className="row prayers-moderating-container">
                                                <div className="col-12">
                                                    <div className="row deleted-posts-table">
                                                        <div className="col-12">
                                                            <Table theadData={tableHeader} tbodyData={activeUsers} tHeaderClassname="table-header active-table-header" tDataClassname="active-table-body" />
                                                        </div>
                                                    </div>
                                                    <div className="row banned-users-table">
                                                        <div className="col-12">
                                                            <Table theadData={bannedTableHeader} tHeaderClassname="table-header  active-table-header" tbodyData={bannedUsers} tDataClassname="active-table-body" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <Modal isOpen={isOpen && selectedUser !== null}
                                        modalBody={<>
                                            <p>{consts.BAN_USER_HEADER}</p>
                                            <p>{consts.BAN_USER_SECOND_HEADER}</p>
                                        </>}
                                        modalFooterButtons={[
                                            { variant: 'secondary', label: 'Yes, ban user', onClick: () => { onBanUser(selectedUser) } },
                                            { label: 'Cancel', onClick: () => { setIsOpen(false); setSelectedUser(null) } }
                                        ]} />
                                    {showMiniSpinner &&
                                        <div className="col-12 align-self-center">
                                            <MiniSpinner />
                                        </div>
                                    }
                                </div>
                            </div>
                            {activeTab < '4' && !allPrayers && !myPrayers && <Spinner />}
                            {renderRequestButton('footer-button', "Add weekly update", () => switchToForm(null))}
                        </>
                        : <StatusBanner
                            bannerAlignment="left"
                            bannerMsg={consts.COMMUNITY_SUPPORT_IS_DOWN}
                            failedStatus
                        />
                    }
                </div>
            </>
            : <NotAuthorized />
    );
}

const mapStateToProps = state => {
    const { userDetails } = state.sso;
    return {
        isPrayerWallAdmin: userDetails && userDetails.IsPrayerWallAdmin,
        token: userDetails && userDetails.AmityToken,
        //token: state.prayerFeature.token,
        memberId: userDetails && userDetails.Id,
        userName: userDetails && userDetails.userName,
        lanId: state.domain.lan,
        connectionState: state.prayerFeature.connectionState,
        activeTab: state.prayerFeature.activeTab,
        _prayerOfTheWeek: state.prayerFeature.prayerOfTheWeek,
        allPrayers: state.prayerFeature.prayers,
        myPrayers: state.prayerFeature.myPrayers,
        hasError: state.prayerFeature.error || state.prayerFeature.hasError,
        hasEditPrayerError: state.prayerFeature.hasEditPrayerError,
        myRecentPrayerPostId: state.prayerFeature.myRecentPrayerPostId,
        updating: state.prayerFeature.updating || state.prayerFeature.updatingMyPrayers,
        loadingMore: state.prayerFeature.loadingMore,
        screenBreakPoint: state.common.screenBreakPoint,
        usersDeletedPosts: state.prayerFeature.usersDeletedPosts,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setupSession: (memberId, token, callback) => {
            dispatch({ type: types.SETUP_AMITY_USER_SESSION, memberId, token, callback });
        },
        subscribeToCommunity: callback => dispatch({ type: types.SUBSCRIBE_TO_COMMUNITY, callback }),
        setConnectionState: connectionState => dispatch({ type: types.AMITY_CONNECTION_CHANGED, connectionState }),
        updateUserRole: userRole => dispatch({ type: types.UPDATE_AMITY_USER_ROLE, userRole }),
        setActiveTab: (activeTab, memberId) => {
            dispatch({ type: types.PRAYER_WALL_TAB_CHANGED, activeTab });
            logUI(types.PRAYER_WALL_TAB_CHANGED, new Date(), tools.getURLPath(), { activeTab }, memberId);
        },
        getPrayerOfTheWeek: callback => dispatch({ type: types.GET_PRAYER_OF_THE_WEEK, callback }),
        getAllPrayers: callback => dispatch({ type: types.GET_ALL_PRAYERS, callback }),
        getMyPrayers: (memberId, callback) => dispatch({ type: types.GET_MY_PRAYERS, memberId, callback }),
        updatePrayerOfTheWeek: (prayers, livePrayers) => dispatch({ type: types.GET_PRAYER_OF_THE_WEEK_SUCCESS, prayers, livePrayers }),
        updateAllPrayers: (prayers, livePrayers, sessionStartTime, callback) =>
            dispatch({ type: types.GET_ALL_PRAYERS_SUCCESS, allPrayers: prayers, livePrayers, sessionStartTime, callback }),
        updateMyPrayers: (prayers, livePrayers) => dispatch({ type: types.GET_MY_PRAYERS_SUCCESS, myPrayersCount: prayers ? prayers.length : 0, prayers, livePrayers }),
        refreshAllPrayers: () => dispatch({ type: types.REFRESH_ALL_PRAYERS }),
        refreshMyPrayers: (memberId) => dispatch({ type: types.REFRESH_MY_PRAYERS, memberId }),
        getNextPrayers: callback => dispatch({ type: types.GET_NEXT_PRAYERS, callback }),
        onEnteringPrayerWall: timestamp => dispatch({ type: types.PRAYER_WALL_ENTERED, timestamp }),
        onLeavingPrayerWall: sessionDurationInMinutes => dispatch({ type: types.PRAYER_WALL_LEFT, sessionDurationInMinutes }),
        getUsersDeletedPosts: (callback) => dispatch({ type: types.GET_USERS_DELETED_POSTS, callback }),
        updateUsersDeletedPosts: deletedPosts => dispatch({ type: types.GET_USERS_DELETED_POSTS_SUCCESS, deletedPosts }),
        banUser: (userId, callback) => dispatch({ type: types.BAN_USER, userId, callback }),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrayerWall);